import React, { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { AdminCard, Badge } from "./AdminLayout";
import { StarRating } from "@/components/store/ProductCard";
import { toast } from "sonner";

export default function AdminReviews() {
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState("");
  const [reply, setReply] = useState({});
  const load = useCallback(() => api.get(`/admin/reviews${filter ? `?status=${filter}` : ""}`).then((r) => setList(r.data)).catch(() => {}), [filter]);
  useEffect(() => { load(); }, [load]);
  const mod = async (id, body) => { await api.put(`/admin/reviews/${id}`, body); toast("Updated"); load(); };
  const del = async (id) => { await api.delete(`/admin/reviews/${id}`); load(); };

  return (
    <div>
      <h1 className="font-serif text-3xl mb-6">Reviews</h1>
      <div className="flex gap-2 mb-4">{["", "pending", "published", "featured"].map((s) => (
        <button key={s} onClick={() => setFilter(s)} className={`text-xs uppercase px-3 py-2 border capitalize ${filter === s ? "bg-sharoa-charcoal text-white" : "border-sharoa-line"}`}>{s || "All"}</button>
      ))}</div>
      <div className="space-y-3">
        {list.map((r) => (
          <AdminCard key={r.id}>
            <div className="flex justify-between">
              <div><StarRating value={r.rating} /><h4 className="font-serif text-lg">{r.title}</h4></div>
              <div className="flex items-center gap-2"><Badge tone={r.status === "published" ? "green" : r.status === "featured" ? "rose" : "amber"}>{r.status}</Badge>{r.verified && <Badge tone="green">Verified</Badge>}</div>
            </div>
            <p className="text-sm text-sharoa-muted mt-1">{r.body}</p>
            <p className="text-xs mt-2">{r.name} · {r.product_name} · {new Date(r.created_at).toLocaleDateString("en-IN")}</p>
            {r.reply && <p className="text-xs bg-sharoa-pale p-2 mt-2">SHAROA: {r.reply}</p>}
            <div className="flex flex-wrap gap-2 mt-3">
              <button onClick={() => mod(r.id, { status: "published" })} className="text-xs uppercase px-3 py-1.5 border border-sharoa-line">Approve</button>
              <button onClick={() => mod(r.id, { featured: !r.featured, status: "featured" })} className="text-xs uppercase px-3 py-1.5 border border-sharoa-line">Feature</button>
              <button onClick={() => mod(r.id, { status: "hidden" })} className="text-xs uppercase px-3 py-1.5 border border-sharoa-line">Hide</button>
              <button onClick={() => del(r.id)} className="text-xs uppercase px-3 py-1.5 border border-red-200 text-red-500">Delete</button>
              <div className="flex gap-1"><input placeholder="Reply…" value={reply[r.id] || ""} onChange={(e) => setReply({ ...reply, [r.id]: e.target.value })} className="border border-sharoa-line px-2 py-1 text-xs" /><button onClick={() => mod(r.id, { reply: reply[r.id] })} className="text-xs uppercase px-3 border border-sharoa-line">Reply</button></div>
            </div>
          </AdminCard>
        ))}
        {list.length === 0 && <p className="text-sharoa-muted text-sm">No reviews.</p>}
      </div>
    </div>
  );
}
